// Tool registry — single source of truth for which tools exist, their
// metadata, and which ones the dashboard renders cards for.
// (brief Section 4.3)

export interface ToolDefinition {
  id: string;
  name: string;
  description: string;
  icon: string;
  route: string;
  apiPrefix: string;
  requiredRole?: string;
  status: "active" | "beta" | "coming-soon";
}

export const TOOL_REGISTRY: ToolDefinition[] = [
  {
    id: "pipe-takeoff",
    name: "Pipe Spool Take-off",
    description: "Extract material quantities from piping shop drawing PDFs",
    icon: "Wrench",
    route: "/tools/pipe-takeoff",
    apiPrefix: "/api/tools/pipe-takeoff",
    status: "active",
  },
  {
    id: "opportunities",
    name: "Opportunity Pipeline",
    description: "Track engineering project opportunities through the sales pipeline",
    icon: "Target",
    route: "/tools/opportunities",
    apiPrefix: "/api/tools/opportunities",
    status: "coming-soon",
  },
  {
    id: "customers",
    name: "Customers",
    description: "Customer database; client records linked to opportunities and projects",
    icon: "Building2",
    route: "/tools/customers",
    apiPrefix: "/api/tools/customers",
    status: "coming-soon",
  },
  {
    id: "production-schedule",
    name: "Production Schedule",
    description: "Plan, schedule, and track fabrication production across active projects",
    icon: "CalendarClock",
    route: "/tools/production-schedule",
    apiPrefix: "/api/tools/production-schedule",
    status: "active",
  },
  {
    id: "cut-to-length",
    name: "Cut To Length Optimiser",
    description: "Optimise cutting yields for stock lengths with kerf-aware nesting and PDF export",
    icon: "Scissors",
    route: "/tools/cut-to-length",
    apiPrefix: "/api/tools/cut-to-length",
    status: "active",
  },
  {
    id: "team-planner",
    name: "Team Planner",
    description: "Rocks, to-dos, opportunities, and team health in one place",
    icon: "LayoutDashboard",
    route: "/tools/team-planner",
    apiPrefix: "/api/tools/team-planner",
    status: "active",
  },
];
